import React from 'react';
// template components
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// icons
import DialGaugeIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/DialGauge';
import FamilyHeartIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/FamilyHeart';
import SettingsSliderv from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/SettingsSlider';
import ShieldWithHeartIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/ShieldWithHeart';
// native components
import UnderstandingProductGrouping from '../../../../components/understandingProductGrouping/understandingProductGrouping';

export const ITEMS = [
  {
    id: 'life-insurance-what-is-it',
    icon: ShieldWithHeartIcon,
    title: <>What&#39;s life <WidowBlock>insurance, exactly&#63;</WidowBlock></>,
    contentAs: 'div',
    content: (
      <Typography disableBottomPadding>
        Life insurance is simple. You make payments (your premium) to us. When you pass away, we pay a set amount of money, (generally tax&#45;free) to the people or institutions you choose (your beneficiaries). It can be your loved ones, your favorite charities, or other non&#45;profits.
      </Typography>
    ),
  },
  {
    id: 'life-insurance-why-do-i-need-it',
    icon: FamilyHeartIcon,
    title: <>Why do I need a life <WidowBlock>insurance policy&#63;</WidowBlock></>,
    contentAs: 'div',
    content: (
      <Typography disableBottomPadding>
        Life insurance will help your loved ones cover expenses like a mortgage, debts, your kids&#39; tuition, and even replace lost income when you&#39;re no longer here. Depending on the type you get, it can also be the foundation for a sound financial plan and help with expenses during your life.
      </Typography>
    ),
  },
  {
    id: 'life-insurance-is-work-coverage-enough',
    icon: SettingsSliderv,
    title: <>Isn&#39;t the life insurance through my <WidowBlock>work enough&#63;</WidowBlock></>,
    contentAs: 'div',
    content: (
      <Typography disableBottomPadding>
        Your life insurance offered through an employer might not give you the coverage you might need, and the rates could go up year after year, costing you more over time. Plus, if you ever leave your job, you can&#39;t take that coverage with you.
      </Typography>
    ),
  },
  {
    id: 'life-insurance-what-if-i-need-a-policy-fast',
    icon: DialGaugeIcon,
    title: <>What if I need a life insurance <WidowBlock>policy fast&#63;</WidowBlock></>,
    contentAs: 'div',
    content: (
      <Typography disableBottomPadding>
        You may be eligible for our exclusive underwriting process. Using the power of data, we can make decisions faster. And we might not need detailed medical records. So, you can get your life insurance application approved as soon as the same day.<sup>1</sup>
      </Typography>
    ),
  },
];

export default () => {
  return (
    <UnderstandingProductGrouping
      id='life-insurance'
      headingText={<>Let&#39;s talk about why life insurance is <WidowBlock>so important.</WidowBlock></>}
      cardDataArray={ITEMS}
    />
  );
};
